<template>
  <div>
    <div class="error-container align-self-center text-center">
      <b-img :src="ErrorIcon" class="align-self-center text-center error-icon-container" alt="error-icon" />
      <div class="error-message-container">
        <h3>Important Note</h3> <p>You are currently logged in as : <b>{{ userEmail }}</b>.<br />
              If your account has been migrated to omc.com, please clear your browser cache or use incognito mode and log in with your <b>omc.com</b> email ID.<br /> 
              If you continue to see this message, Please <a :href="`mailto:${TeamEmail}`">contact the Financial Systems team</a></p>
      </div>
    </div>
  </div>
</template>
<style scoped>
.error-container {
  text-align: center;
  max-width:calc(100% - 40%);
  max-height: 350px;
  min-height: 350px;
  border-radius: 5px;
  margin: 0 auto;
  margin-top:3rem !important;
  background-color: rgba(216, 216, 216, 0.2);
}
 .error-message-container {
  height: 68px;
  margin-top: 31px;
} 
.error-message-container p {
  font-family: 'Open Sans';
  font-size: 25px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.02px;
  text-align: center;
  color: #4d5161;
}
.error-icon-container {
  margin-top:1.66rem;
}
.error-message-container p {
  margin-bottom: 0px;
}
.error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(50%, 50%);
}
</style>
<script>
export default {
  name: "invalidLogged",
  data() {
    return {
      userEmail: null,
      ErrorIcon: require("@/assets/Icons/Warning.svg"),
      TeamEmail:process.env.VUE_APP_SUPPORT_MAIL
    };
  },
  created() {
    this.getEmailFromStore();
  },
  props: {
    message: null,
  },
  methods:{
    async getEmailFromStore() {
      this.userEmail = await this.$store.dispatch("getEmail");
    },
  }
};
</script>

